import { FilterFieldType, IFilter } from './types'

/**
 * Filter config for the Workflows admin page. Workflows are code-registered,
 * so this config is consumed purely client-side (no server filter pushdown) —
 * the `dbField`/`alias` fields used by SQL-backed lists are intentionally
 * omitted. Options for the `workflowName` autocomplete are filled in at render
 * time from the loaded workflows list.
 *
 * Column order in the config drives column order in the table.
 */
export const ATLAS_WORKFLOWS_FILTERS_CONFIG = [
  {
    field: 'workflowName',
    type: FilterFieldType.Autocomplete,
    isSortable: true,
    isMultiple: true,
    title: 'Workflow',
  },
  {
    // Display-only column — description text renders in the body and is
    // picked up by Full Search; no per-column filter UI.
    field: 'description',
    type: FilterFieldType.Text,
    title: 'Description',
    excludeFilter: true,
  },
] as const satisfies IFilter[]
